import { ApolloClient, InMemoryCache } from "@apollo/client";

export const apiUrl =
    process.env.MIX_APP_ENV === "production"
        ? process.env.MIX_UPLOADS_PROD_DOMAIN
        : process.env.MIX_UPLOADS_LOCAL_DOMAIN;

const cache = new InMemoryCache();

export const client = new ApolloClient({
    cache,
    uri: `${apiUrl}/graphql`,
});

export const dataSlider = [
    {
        id: 1,
        src: "https://nlslighting.com/wp-content/uploads/2022/02/LEDucation_homeslider.jpg",
    },
    {
        id: 2,
        src: "https://nlslighting.com/wp-content/uploads/2022/02/NV-W_higherLumens_homeslider_v5.jpg",
    },
    {
        id: 3,
        src: "https://nlslighting.com/wp-content/uploads/2022/01/SSL_mag_announcement_homepage_slider_03_2500.jpg",
    },
    {
        id: 4,
        src: "https://nlslighting.com/wp-content/uploads/2022/01/nvf_homeslider_2500_v3.jpg",
    },
    {
        id: 5,
        src: "https://nlslighting.com/wp-content/uploads/2022/02/QuickShipFlash_slider.jpg",
    },
    {
        id: 6,
        src: "https://nlslighting.com/wp-content/uploads/2022/01/home_trac_slider_v2_2500.jpg",
    },
    {
        id: 7,
        src: "https://nlslighting.com/wp-content/uploads/2022/01/NVW_homeslider_2500.jpg",
    },
    //use the data of the commented element on Slider.js separately from the array
    // {
    //     id: 8,
    //     src: "https://nlslighting.com/wp-content/uploads/2022/01/Why_Silicone_banner_2500.jpg",
    // },
];

export const logos = [
    {
        id: 1,
        src: "images/logos/CBS.png",
        alt: "CBS Logo",
    },
    {
        id: 2,
        src: "images/logos/Southern Nazarene University – College Days.png",
        alt: "Southern Nazarene University – College Days Logo",
    },
    {
        id: 3,
        src: "images/logos/staples.png",
        alt: "Staples Logo",
    },
    {
        id: 4,
        src: "images/logos/Chevrolet.png",
        alt: "Chevrolet Logo",
    },
    {
        id: 5,
        src: "images/logos/McCarran International Airport.png",
        alt: "McCarran International Airport Logo",
    },
    {
        id: 6,
        src: "images/logos/Carson City School District.png",
        alt: "Carson City School District Logo",
    },
    {
        id: 7,
        src: "images/logos/Boyd Gaming.png",
        alt: "Boyd Gaming Logo",
    },
    {
        id: 8,
        src: "images/logos/Walt Disney Imagineering.png",
        alt: "Walt Disney Imagineering Logo",
    },
];
